<template>
  <el-container class="body_container">
    <!--<el-row class="head_line">直播</el-row>-->
    <el-header style="height: 100px;padding:0px">
      <el-row class="body_title">审核</el-row>
      <el-row type="flex">
        <el-col>
          <el-form class="search_select" v-model="searchVo" :inline="true" size="small">
            <el-form-item style="margin: 0px">
              <el-input v-model="searchVo.title" placeholder="输入名字查询" style="width: 300px">
                <el-button slot="append" @click="search" icon="el-icon-search"></el-button>
              </el-input>
              <!--<el-input placeholder="请输入内容" v-model="searchVo.title" class="input-with-select">-->
              <!--<el-button slot="append" icon="el-icon-search"></el-button>-->
              <!--</el-input>-->
            </el-form-item>
            <el-form-item class="dialog-footer" >
              <el-button type="primary" @click="restSearch">重置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-header>
    <el-main class="search_result emp_search_result">
      <el-table :data="lawyers.list">
        <el-table-column prop="name" label="姓名" min-width="90px"></el-table-column>
        <el-table-column prop="code" label="律师证编号" min-width="155px"></el-table-column>
        <el-table-column prop="email" label="邮箱" min-width="150px"></el-table-column>
        <el-table-column prop="register" label="审核状态" :formatter="formatterColumn" min-width="100px"></el-table-column>
        <el-table-column prop="id" label="操作" width="100px">
          <template slot-scope="scope">
            <!--<el-button size="mini" @click="checkQuote(scope.row)">-->
            <i class="el-icon-edit" @click="checkLawyer(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            <check-lawyer ref="checkLawyer" v-if="checkLawyerVisible" :visible.sync="checkLawyerVisible" @callFather="reload" :values="lawyerId"></check-lawyer>
            <!--&nbsp;-->
            <!--<i class="el-icon-delete" @click="delLawyer(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>-->
            <!--</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-pagination class="page"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-size="lawyers.rows"
                   :current-page="lawyers.page"
                   layout="prev, pager, next, jumper"
                   :total="lawyers.total">
    </el-pagination>
  </el-container>
</template>

<script>
import Check from './check/Check.vue'
import lawyer from '@/api/lawyer'
import axios from 'axios'
import store from '../../store/index'
export default {
  name: 'Lawyer',
  data () {
    return {
      value: true,
      lawyerId: null,
      checkLawyerVisible: false,
      lawyers: {
        page: 1,
        rows: 10,
        total: 0,
        list: []
      },
      searchVo: {
        category: 'name',
        title: ''
      },
      value2: '1',
      page: 1,
      size: 10
    }
  },
  methods: {
    checkLawyer (row) {
      this.lawyerId = row.id
      this.checkLawyerVisible = true
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`)
      this.page = val
      this.reload()
    },
    reload () {
      lawyer.find({page: this.page, rows: this.size, register: 'n'}).then(res => {
        this.lawyers = res.data.data
        // console.log(this.lawyers)
      })
    },
    formatterColumn (row, column) {
      return row.register === '0' ? '正常' : row.register === '1' ? '待审核' : row.register === '2' ? '审核未通过' : ''
    },
    search () {
      let obj={}
      obj.name  = this.searchVo.title
      obj.page = this.page
      obj.size = this.size
      // let category = this.searchVo.category
      lawyer.find(obj/*{page: this.page, rows: this.size, category : this.searchVo.title}*/).then(res => {
        this.lawyers = res.data.data
      })
    },
    restSearch () {
     this.searchVo = {}
    },
    updateData (val) {
      this.page = val
      this.reload()
    }
  },
  components: {
    'check-lawyer': Check
  },
  created () {
    this.reload()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lawyer/Check.vue